module.exports = __webpack_public_path__ + "img/phone.4eee83e1.png";